<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeClients.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeClients.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <query-client-tag-input
            v-model="clientsSelected"
            :societeActiveId="societeActiveId"
            :label="$t('listeClients.filtre.clients')">
          </query-client-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.code')">
            <qd-taginput type='is-primary' v-model="critereRecherche.codes"></qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <query-tag-input :label="$t('listeClients.filtre.tags')"
            v-model="critereRecherche.tagIds"
            :query="(search) => func.getAllTags({
              query: {
                actif: true,
                auto: search,
                moduleTag: constantes.CLIENT,
              },
            })">
            <template slot-scope="props">
              {{ props.option.libelle }}
            </template>
          </query-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.nom')">
            <qd-taginput type='is-primary' v-model="critereRecherche.nomsCommercialOuNomsJuridique">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.prospect')">
            <b-select v-model="critereRecherche.prospect">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeClients.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeClients.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.adresse')">
            <qd-taginput type='is-primary' v-model="critereRecherche.adresses"></qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.ville')">
            <ville-tag-input-auto-complete
                :critere-recherche="this.critereRecherche"
                table-name="Tiers"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.codePostal')">
            <qd-taginput type='is-primary' v-model="critereRecherche.codesPostaux"></qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.secteurActivite')">
            <qd-taginput v-if="secteurActiviteTags"
                        v-model="secteurActiviteSelected"
                        :data="secteurActiviteTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredSecteurActiviteTags"
                        @input="getSecteurActiviteTag">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pbd-0">
          <user-tag-input
            :label="$t('listeClients.filtre.commercial')"
            :blocked="userIsCommercialBlocked"
            v-model="commercialSelected"
            v-if="critereRecherche.commercialIds"
            :items="listeCommercial"
          />
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.compteComptable')">
            <qd-taginput type='is-primary' v-model="critereRecherche.comptesComptable">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listeClients.filtre.typologie')"
                        :items="constantes.LISTE_TYPOLOGIE_FILTRE"
                        v-model="typologiesSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.codeMagasin')">
            <qd-taginput type='is-primary' v-model="critereRecherche.codesMagasin"></qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.typePointVente')">
            <qd-taginput v-if="typePointVenteTags"
                        v-model="typePointVenteSelected"
                        :data="typePointVenteTags"
                        type="is-primary"
                        icon="magnify"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        @typing="getFilteredTypePointVenteTags"
                        @input="getTypePointVenteTag">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listeClients.filtre.blocageLevel')"
                        :items="constantes.LEVEL_BLOCAGE"
                        v-model="levelsSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
            :label="$t('listeClients.filtre.marque')"
            :items="marques"
            field="libelle"
            v-model="marquesSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.archive')">
            <b-select v-model="critereRecherche.archive">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeClients.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeClients.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeClients.filtre.avecCoordonnees')">
            <b-select v-model="critereRecherche.avecCoordonnees">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeClients.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeClients.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="moduleStockTiersActive">
          <b-field :label="$t('listeClients.filtre.estLieuStockage')">
            <b-select v-model="critereRecherche.estLieuStockage">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeClients.filtre.actions.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeClients.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/clients-mutation-type';
import genererCriteresRechercheClient from '@/services/bodac/client/criteresRecherche/genererCriteresRechercheClient';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import initialUsers from '@/services/general/filters/filterinitUsers';
import userTagInput from '@/components/general/tagInput/userTagInput';
import messageErreur from '@/services/general/messageErreur';
import { LISTE_TYPOLOGIE_FILTRE } from '@/configuration/tiers/tiersConf';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { LEVEL_BLOCAGE } from '@/configuration/tiers/levelBlocage';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { CLIENT } from '@/configuration/parametrage/tagConf';
import { getAll as getAllTags } from '@/api/tag/index';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  props: {
    isCartographie: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    libelleTagInput,
    VilleTagInputAutoComplete,
    queryClientTagInput,
    userTagInput,
    queryTagInput,
  },
  data() {
    return {
      critereRecherche: null,
      listeSecteurActiviteBase: [],
      secteurActiviteSelected: [],
      secteurActiviteTags: [],
      typologiesSelected: [],
      levelsSelected: [],
      listeCommercial: [],
      commercialSelected: [],
      constantes: {
        LISTE_TYPOLOGIE_FILTRE,
        LEVEL_BLOCAGE,
        COMMERCIAL,
        DIRECTEUR_COMMERCIAL,
        CLIENT,
      },
      listeTypePointVenteBase: [],
      typePointVenteSelected: [],
      typePointVenteTags: [],
      clientsSelected: [],
      marquesSelected: [],
      func: {
        getAllTags,
      },
    };
  },
  computed: {
    storeName() {
      return this.isCartographie ? 'clientCartographie' : 'clients';
    },
    criteresRechercheFromStore() {
      return this.$store.getters[`${this.storeName}/criteresRecherche`];
    },
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    secteursActivite() {
      return this.parametre(PARAMETRES_KEYS.secteurActivite).filter(e => e.actif);
    },
    typesPointVente() {
      return this.parametre(PARAMETRES_KEYS.typePointVente)
        .filter(typePointVente => typePointVente.actif);
    },
    marques() {
      return this.parametre(PARAMETRES_KEYS.marque).filter(marque => marque.actif);
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    blocageFiltreCommercial() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercial() {
      return (this.user.profil === COMMERCIAL);
    },
    userIsCommercialBlocked() {
      return this.userIsCommercial && this.blocageFiltreCommercial;
    },
  },
  methods: {
    setCritereRecherche(critere) {
      return this.$store.commit(`${this.storeName}/${SET_CRITERE_RECHERCHE}`, critere);
    },
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCriteresRechercheClient(this.isCartographie));
      this.secteurActiviteSelected = [];
      this.typologiesSelected = [];
      this.levelsSelected = [];
      this.clientsSelected = [];
      this.marquesSelected = [];
      this.commercialSelected = [];
      this.typePointVenteSelected = [];
      this.getSecteurActiviteTag();
      this.getTypePointVenteTag();
    },
    appliquerCritere() {
      this.critereRecherche.secteursActiviteIds = this.secteurActiviteSelected.map(s => s.id);
      this.critereRecherche.typologie = this.typologiesSelected.map(c => c.code);
      this.critereRecherche.typesPointVente = this.typePointVenteSelected.map(t => t.id);
      this.critereRecherche.blocageLevel = this.levelsSelected.map(c => c.key);
      this.critereRecherche.tiers = this.clientsSelected;
      this.critereRecherche.commercialIds = this.commercialSelected.map(c => c.id);
      this.critereRecherche.marqueIds = this.marquesSelected.map(el => {
        return el.id;
      });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    getFilteredSecteurActiviteTags(text) {
      this.getSecteurActiviteTag();
      this.secteurActiviteTags = this.secteurActiviteTags.filter((secteur) => {
        return secteur.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getSecteurActiviteTag() {
      this.secteurActiviteTags = this.listeSecteurActiviteBase.filter((secteur) => {
        return !this.secteurActiviteSelected.map(a => a.id).includes(secteur.id);
      });
    },
    getFilteredTypePointVenteTags(text) {
      this.getTypePointVenteTag();
      this.typePointVenteTags = this.typePointVenteTags.filter((typePointVente) => {
        return typePointVente.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getTypePointVenteTag() {
      this.typePointVenteTags = this.listeTypePointVenteBase.filter((typePointVente) => {
        return !this.typePointVenteSelected.map(a => a.id).includes(typePointVente.id);
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.criteresRechercheFromStore);
        await this.loadParametres([
          PARAMETRES_KEYS.typePointVente,
          PARAMETRES_KEYS.secteurActivite,
          PARAMETRES_KEYS.marque,
        ]);
        await this.loadParametreUtilisateur();
        await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
        this.listeSecteurActiviteBase = this.secteursActivite;
        this.secteurActiviteSelected = this.listeSecteurActiviteBase.filter((secteur) => {
          return this.critereRecherche.secteursActiviteIds.includes(secteur.id);
        });
        this.getSecteurActiviteTag();

        this.typologiesSelected = this.constantes.LISTE_TYPOLOGIE_FILTRE.filter((typo) => {
          return this.critereRecherche.typologie.includes(typo.code);
        });

        this.levelsSelected = this.constantes.LEVEL_BLOCAGE.filter((level) => {
          return this.critereRecherche.blocageLevel.includes(level.key);
        });

        this.listeTypePointVenteBase = this.typesPointVente;
        this.typePointVenteSelected = this.listeTypePointVenteBase.filter((typePointVente) => {
          return this.critereRecherche.typesPointVente.includes(typePointVente.id);
        });
        this.clientsSelected = this.critereRecherche.tiers;

        await updateCritereWithParametreInterne(this.critereRecherche);
        const users = this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(user => user.actif);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeLignesDevis.filtre.noCommercial'));
        this.commercialSelected = this.listeCommercial.filter((commercial) => {
          return this.critereRecherche.commercialIds.includes(commercial.id);
        });

        this.getTypePointVenteTag();
        if (this.critereRecherche.marqueIds) {
          this.marquesSelected = this.marques.filter((c) => {
            return this.critereRecherche.marqueIds.includes(c.id);
          });
        }
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
        ]);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
